import { contentList, type ContentCategory, type ContentItem } from '@/mocks/content';

export const formatDate = (iso: string): string => {
  const [y, m, d] = iso.split('-');
  return `${y}年${Number(m)}月${Number(d)}日`;
};

export const formatShortDate = (iso: string): string => {
  const [, m, d] = iso.split('-');
  return `${Number(m)}月${Number(d)}日`;
};

export const formatViews = (views: number): string => {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return `${views}`;
};

export const getById = (id: string): ContentItem | undefined =>
  contentList.find((item) => item.id === id);

export const getByCategory = (category: ContentCategory): ContentItem[] =>
  contentList.filter((item) => item.category === category);

export const getFeatured = (): ContentItem[] =>
  contentList.filter((item) => item.featured);

export const getRelated = (item: ContentItem, limit = 4): ContentItem[] =>
  contentList
    .filter((c) => c.category === item.category && c.id !== item.id)
    .sort((a, b) => b.views - a.views)
    .slice(0, limit);

export const sortByLatest = (list: ContentItem[]): ContentItem[] =>
  [...list].sort((a, b) => b.date.localeCompare(a.date));

export const sortByHot = (list: ContentItem[]): ContentItem[] =>
  [...list].sort((a, b) => b.views - a.views);

export const searchContent = (keyword: string): ContentItem[] => {
  const kw = keyword.trim().toLowerCase();
  if (!kw) return [];
  return contentList.filter(
    (item) =>
      item.title.toLowerCase().includes(kw) ||
      item.summary.toLowerCase().includes(kw) ||
      item.tag.toLowerCase().includes(kw) ||
      item.author.toLowerCase().includes(kw)
  );
};

export const getTags = (category: ContentCategory): string[] => {
  const tags = contentList
    .filter((item) => item.category === category)
    .map((item) => item.tag);
  return Array.from(new Set(tags));
};